import React, { useState } from 'react';

export function HomeLeadForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    postcode: '',
    message: '',
    website_url: ''
  });
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleChange = (event) => {
    setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('submitting');
    setMessage('');

    if (formData.website_url) {
      setStatus('success');
      return;
    }

    try {
      const response = await fetch('https://api.dev.auxo.dkwebform/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.message || 'Din besked kunne ikke sendes.');
      }

      setStatus('success');
      setFormData({ name: '', phone: '', email: '', postcode: '', message: '', website_url: '' });
    } catch (error) {
      setStatus('error');
      setMessage(error.message || 'Der opstod en fejl. Prøv venligst igen.');
    }
  };

  if (status === 'success') {
    return (
      <div className="bg-[#E6EBEF] px-7 py-10 text-center shadow-[0_14px_32px_rgba(11,14,20,0.14)] sm:px-10">
        <i className="fa-light fa-circle-check text-4xl text-[#206FEA]" aria-hidden="true" />
        <h2 className="mt-4 text-2xl font-semibold text-[#0B0E14]">Tak for din henvendelse</h2>
        <p className="mt-3 text-sm leading-7 text-slate-600">Vi har modtaget din besked og vender tilbage hurtigst muligt.</p>
        <button type="button" onClick={() => setStatus('idle')} className="mt-6 rounded-xl border border-[#206FEA] px-6 py-3 text-sm font-semibold text-[#206FEA] transition-colors hover:bg-[#206FEA] hover:text-white">Send en ny besked</button>
      </div>
    );
  }

  const inputClass = 'w-full border border-[#CBD5E1] bg-white px-3 py-3 text-sm text-[#0B0E14] outline-none transition focus:border-[#206FEA] focus:ring-1 focus:ring-[#206FEA]';

  return (
    <div className="bg-[#E6EBEF] px-6 py-8 shadow-[0_14px_32px_rgba(11,14,20,0.14)] sm:px-9 sm:py-10">
      <div className="text-center">
        <h2 className="text-3xl font-semibold tracking-tight text-[#0B0E14]">Kontakt os</h2>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-slate-600">Ring på <a href="tel:+4520743420" className="font-semibold text-[#206FEA] hover:underline">(+45) 20 74 34 20</a> eller skriv til <a href="mailto:Joenomontage@gmail.com" className="font-semibold text-[#206FEA] hover:underline">Joenomontage@gmail.com</a></p>
      </div>
      <form onSubmit={handleSubmit} className="mt-7 space-y-4">
        <div className="sr-only absolute -left-[9999px]" aria-hidden="true">
          <label htmlFor="home-website-url">Website URL</label>
          <input id="home-website-url" type="text" name="website_url" value={formData.website_url} onChange={handleChange} tabIndex={-1} autoComplete="off" />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <input className={inputClass} id="home-name" name="name" required value={formData.name} onChange={handleChange} placeholder="Navn" aria-label="Navn" />
          <input className={inputClass} id="home-phone" name="phone" type="tel" required value={formData.phone} onChange={handleChange} placeholder="Telefon" aria-label="Telefon" />
        </div>
        <input className={inputClass} id="home-email" name="email" type="email" required value={formData.email} onChange={handleChange} placeholder="E-mail" aria-label="E-mail" />
        <div>
          <input className={inputClass} id="home-postcode" name="postcode" inputMode="numeric" value={formData.postcode} onChange={handleChange} placeholder="Postnummer" aria-label="Postnummer" />
        </div>
        <textarea className={`${inputClass} min-h-28 resize-y`} id="home-message" name="message" required value={formData.message} onChange={handleChange} placeholder="Besked" aria-label="Besked" />
        {status === 'error' && <p className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{message}</p>}
        <button type="submit" disabled={status === 'submitting'} className="w-full rounded-xl bg-[#206FEA] px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#206FEA]/85 disabled:cursor-not-allowed disabled:opacity-60">
          {status === 'submitting' ? 'Sender besked ...' : 'Send besked'}
        </button>
      </form>
    </div>
  );
}
